import { SemanticColors } from '../../../../tokens/colors/types';
import { blue, green, orange, red } from './palette';

export const info: SemanticColors['info'] = {
  '20': blue[20],
  '30': blue[30],
  '50': blue[50],
  '70': blue[70],
  '90': blue[90],
};

export const positive: SemanticColors['positive'] = {
  '20': green[20],
  '30': green[30],
  '50': green[50],
  '70': green[70],
  '90': green[90],
};

export const critical: SemanticColors['critical'] = {
  '20': red[20],
  '30': red[30],
  '50': red[50],
  '70': red[70],
  '90': red[90],
};

export const warning: SemanticColors['warning'] = {
  '20': orange[20],
  '30': orange[30],
  '50': orange[50],
  '70': orange[70],
  '90': orange[90],
};
